import axios from "axios";
import { Config } from "../Config";
import { userAccessToken } from "../helpers";


export const fetchAIChartings = (filter) => {
  const {
    page,
    per_page,
    status,
    chart_type,
    search_term,
    dos,
    first_name,
    last_name,
    dob,
    sex,
    mobile_phone,
    start_age,
    end_age,
    insurance_ids,
    city,
    state,
    zip,
    account_id,
    location_id,
    order_by,
    vt_name
  } = filter;

  if (account_id === 0) {
    return false;
  }

  let statusParam = status ? `&status=${status}` : "";
  let searchParam = search_term ? `&search_term=${search_term}` : "";
  let dosDateParam = dos ? `&dos=${dos}` : "";
  let chartParam = chart_type ? `&chart_type=${chart_type}` : "";
  let firstName = first_name ? `&first_name=${first_name}` : "";
  let lastName = last_name ? `&last_name=${last_name}` : "";
  let patientDOB = dob ? `&dob=${dob}` : "";
  let patientSex = sex ? `&sex=${sex}` : "";
  let PatientPhone = mobile_phone ? `&mobile_phone=${mobile_phone}` : "";
  let startAge = start_age ? `&start_age=${start_age}` : "";
  let endAge = end_age ? `&end_age=${end_age}` : "";
  let insuranceIds = "";
    if (insurance_ids?.length > 0) {
      insuranceIds = insurance_ids?.map((id) => `&insurance_ids=${id}`).join("");
    }
  let sCity = city ? `&city=${city}` : "";
  let sState = state ? `&state=${state}` : "";
  let sZip = zip ? `&zip=${zip}` : "";
  let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";
  let vtName = vt_name ? `&vt_name=${vt_name}` : "";

  return axios.get(
    `${Config.apiServerUrl}/all/chart?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}${statusParam}${chartParam}${firstName}${lastName}${patientDOB}${patientSex}${PatientPhone}${startAge}${endAge}${insuranceIds}${sCity}${sState}${sZip}${searchParam}${dosDateParam}${orderBy}${vtName}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );

};

export const loadReasonForVisit = async () => {
  try {
    const response = await axios.get(
      `${Config.apiServerUrl}/all/reason_for_visit_name`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {}
};

export const loadVisitType = async () => {
  try {
    const response = await axios.get(
      `${Config.apiServerUrl}/all/visit_type`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {}
};

export const loadRFVCategory = async (rfv_ids) => {
  try {
    const response = await axios.post(
      `${Config.apiServerUrl}/search/rfv_category`,
      { rfv_id: rfv_ids },
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {}
};

export const createChart = async (chartData) => {
  try {
    const response = await axios.post(`${Config.apiServerUrl}/chart/create-new-chart`,chartData,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {}
};

export const getAllMedication = async (rfv_ids = []) => {
  const searchRfvIds = { "rfv_ids": rfv_ids };
  try {
    const response = await axios.post(`${Config.apiServerUrl}/search/medication`, searchRfvIds,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {}
};

export const getAssessmentData = async (icdCodes = []) => {
  const query = { "icd_codes": icdCodes };
  try {
    const response = await axios.post(`${Config.apiServerUrl}/search/assessment`, query,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {}
};

export const updateReasonForVisit = async (paramsData = {}) => {    
  try {
    const response = await axios.post(`${Config.apiServerUrl}/store/reason_for_visit`, paramsData,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {}
};

export const saveAssessmentMedication = async (paramsData = {}) => {    
  try {
    const response = await axios.post(`${Config.apiServerUrl}/store/assessment_medication`, paramsData,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {}
};

export const aiChartHPI = async (paramsData = {}) => {    
  try {
    const response = await axios.post(`${Config.apiServerUrl}/openai/chat_hpi`, paramsData,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {}
};

export const chatAssesment = async (paramsData = {}) => {    
  try {
    const response = await axios.post(`${Config.apiServerUrl}/openai/chat_assessment`, paramsData,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {}
};

export const generateCustomChat = (formData) => {
  try {
    const response = axios.post(`${Config.apiServerUrl}/ai/docflow`, formData,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;

  } catch (error) {
    return error?.response?.data;
  }
};

export const fetchDocflowTemplates = (filter) => {
  const {
    page,
    per_page,
    account_id,
    location_id,
    status,
    search_term,
    order_by
  } = filter;

  if (account_id === 0) {
    return false;
  }

  let statusParam = status ? `&status=${status}` : "";
  let searchParam = search_term ? `&search_term=${search_term}` : "";
  let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";

  return axios.get(
    `${Config.apiServerUrl}/ai/docflow-template/all?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}${statusParam}${searchParam}${orderBy}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
};

export const AddDocflowCategory = async (data) => {
  try {
    const response = await axios.post(`${Config.apiServerUrl}/ai/docflow-template/store`,data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const UpdateDocflowCategory = async (data) => {
  try {
    const response = await axios.put(`${Config.apiServerUrl}/ai/docflow-template/update`,data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const deleteDocflowCategory = (id, account_id, practice_id) => {
  try {
    const response = axios.delete(`${Config.apiServerUrl}/ai/docflow-template/delete?account_id=${account_id}&location_id=${practice_id}&docflow_template_id=${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;

  } catch (error) {
    return error?.response?.data;
  }
};


export const fetchPracticeDocflowTemplates = (account_id) => {
  if (account_id === 0) {
    return false;
  }

  return axios.get(
    `${Config.apiServerUrl}/ai/docflow-template/all_active?account_id=${account_id}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
};

export const fetchDocflowTemplatePrompts = (account_id, id) => {

  return axios.get(`${Config.apiServerUrl}/ai/docflow-template/find?account_id=${account_id}&docflow_template_id=${id}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
};
